__turbopack_context__.v({
  "h2": "Qi08Za_h2",
  "h3": "Qi08Za_h3",
  "p": "Qi08Za_p",
});
